export const translations = {
    fr: {
        title: "Enregistrement",
        subtitle: "Importez votre carte de visite ou remplissez le formulaire",
        uploadTitle: "Carte de visite (Optionnel)",
        optional: "(Optionnel)",
        uploadPlaceholder: "Cliquez pour importer une carte de visite",
        uploadClick: "Cliquez pour importer",
        uploadCardText: "une carte de visite",
        analyzing: "Analyse en cours...",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        company: "Entreprise",
        position: "Poste",
        address: "Adresse",
        website: "Site web",
        password: "Code d'accès",
        passwordPlaceholder: "Code à 6 chiffres",
        passwordHelp: "⚠️ Important : Ne pas utiliser le même code que pour vos données sensibles (bancaires, etc.)",
        passwordError: "Le code doit contenir exactement 6 chiffres",
        homeNeeds: "Besoins pour la maison",
        homeNeedsOptions: {
            electrician: "Électricien",
            plumber: "Plombier",
            painter: "Peintre",
            carpenter: "Menuisier",
            roofing: "Couvreur",
            heating: "Chauffagiste",
            gardener: "Jardinier",
            cleaner: "Nettoyage",
            renovation: "Rénovation",
            other: "Autre"
        },
        submit: "Enregistrer",
        submitting: "Enregistrement...",
        success: "Enregistrement réussi!",
        error: "Erreur lors de l'enregistrement",
        validation: {
            required: "Ce champ est obligatoire",
            email: "Format d'email invalide (doit avoir une extension valide, ex: .com)",
            phone: "Format de téléphone invalide",
            website: "Format d'URL invalide (doit avoir une extension valide, ex: .com, .be)",
            password: "Le code doit contenir exactement 6 chiffres"
        },
        ocr: {
            processing: "Analyse de la carte en cours...",
            success: (n) => `Carte analysée! ${n} champ${n > 1 ? 's' : ''} complété${n > 1 ? 's' : ''}.`,
            noInfo: "Texte détecté mais aucune information reconnue. Complétez manuellement.",
            error: "Impossible d'analyser la carte. Veuillez remplir manuellement.",
            unavailable: "OCR non disponible. Veuillez remplir manuellement.",
            invalidImage: "Veuillez sélectionner une image valide."
        }
    },
    en: {
        title: "Registration",
        subtitle: "Upload your business card or fill out the form",
        uploadTitle: "Business Card (Optional)",
        optional: "(Optional)",
        uploadPlaceholder: "Click to upload a business card",
        uploadClick: "Click to upload",
        uploadCardText: "a business card",
        analyzing: "Analyzing...",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        company: "Company",
        position: "Position",
        address: "Address",
        website: "Website",
        password: "Access Code",
        passwordPlaceholder: "6-digit code",
        passwordHelp: "⚠️ Important: Do not use the same code as for your sensitive data (banking, etc.)",
        passwordError: "The code must contain exactly 6 digits",
        homeNeeds: "Home Needs",
        homeNeedsOptions: {
            electrician: "Electrician",
            plumber: "Plumber",
            painter: "Painter",
            carpenter: "Carpenter",
            roofing: "Roofer",
            heating: "Heating Specialist",
            gardener: "Gardener",
            cleaner: "Cleaning",
            renovation: "Renovation",
            other: "Other"
        },
        submit: "Register",
        submitting: "Registering...",
        success: "Registration successful!",
        error: "Error during registration",
        validation: {
            required: "This field is required",
            email: "Invalid email format (must have a valid extension, e.g. .com)",
            phone: "Invalid phone format",
            website: "Invalid URL format (must have a valid extension, e.g. .com, .be)",
            password: "The code must contain exactly 6 digits"
        },
        ocr: {
            processing: "Analyzing card...",
            success: (n) => `Card analyzed! ${n} field${n > 1 ? 's' : ''} completed.`,
            noInfo: "Text detected but no information recognized. Please fill manually.",
            error: "Unable to analyze card. Please fill manually.",
            unavailable: "OCR unavailable. Please fill manually.",
            invalidImage: "Please select a valid image."
        }
    },
    de: {
        title: "Registrierung",
        subtitle: "Laden Sie Ihre Visitenkarte hoch oder füllen Sie das Formular aus",
        uploadTitle: "Visitenkarte (Optional)",
        optional: "(Optional)",
        uploadPlaceholder: "Klicken Sie, um eine Visitenkarte hochzuladen",
        uploadClick: "Klicken Sie, um",
        uploadCardText: "eine Visitenkarte hochzuladen",
        analyzing: "Analyse...",
        firstName: "Vorname",
        lastName: "Nachname",
        email: "E-Mail",
        phone: "Telefon",
        company: "Unternehmen",
        position: "Position",
        address: "Adresse",
        website: "Website",
        password: "Zugangscode",
        passwordPlaceholder: "6-stelliger Code",
        passwordHelp: "⚠️ Wichtig: Verwenden Sie nicht denselben Code wie für Ihre sensiblen Daten (Banking, etc.)",
        passwordError: "Der Code muss genau 6 Ziffern enthalten",
        homeNeeds: "Hausbedarf",
        homeNeedsOptions: {
            electrician: "Elektriker",
            plumber: "Klempner",
            painter: "Maler",
            carpenter: "Tischler",
            roofing: "Dachdecker",
            heating: "Heizungstechniker",
            gardener: "Gärtner",
            cleaner: "Reinigung",
            renovation: "Renovierung",
            other: "Andere"
        },
        submit: "Registrieren",
        submitting: "Registrierung läuft...",
        success: "Registrierung erfolgreich!",
        error: "Fehler bei der Registrierung",
        validation: {
            required: "Dieses Feld ist erforderlich",
            email: "Ungültiges E-Mail-Format",
            phone: "Ungültiges Telefonformat",
            website: "Ungültiges URL-Format",
            password: "Der Code muss genau 6 Ziffern enthalten"
        },
        ocr: {
            processing: "Karte wird analysiert...",
            success: (n) => `Karte analysiert! ${n} Feld${n > 1 ? 'er' : ''} ausgefüllt.`,
            noInfo: "Text erkannt, aber keine Informationen erkannt. Bitte manuell ausfüllen.",
            error: "Karte kann nicht analysiert werden. Bitte manuell ausfüllen.",
            unavailable: "OCR nicht verfügbar. Bitte manuell ausfüllen.",
            invalidImage: "Bitte wählen Sie ein gültiges Bild."
        }
    },
    nl: {
        title: "Registratie",
        subtitle: "Upload uw visitekaartje of vul het formulier in",
        uploadTitle: "Visitekaartje (Optioneel)",
        optional: "(Optioneel)",
        uploadPlaceholder: "Klik om een visitekaartje te uploaden",
        uploadClick: "Klik om te uploaden",
        uploadCardText: "een visitekaartje",
        analyzing: "Analyseren...",
        firstName: "Voornaam",
        lastName: "Achternaam",
        email: "E-mail",
        phone: "Telefoon",
        company: "Bedrijf",
        position: "Functie",
        address: "Adres",
        website: "Website",
        password: "Toegangscode",
        passwordPlaceholder: "6-cijferige code",
        passwordHelp: "⚠️ Belangrijk: Gebruik niet dezelfde code als voor uw gevoelige gegevens (bankieren, etc.)",
        passwordError: "De code moet exact 6 cijfers bevatten",
        homeNeeds: "Huishoudelijke behoeften",
        homeNeedsOptions: {
            electrician: "Elektricien",
            plumber: "Loodgieter",
            painter: "Schilder",
            carpenter: "Timmerman",
            roofing: "Dakdekker",
            heating: "Verwarmingstechnicus",
            gardener: "Tuinman",
            cleaner: "Schoonmaak",
            renovation: "Renovatie",
            other: "Andere"
        },
        submit: "Registreren",
        submitting: "Bezig met registreren...",
        success: "Registratie succesvol!",
        error: "Fout tijdens registratie",
        validation: {
            required: "Dit veld is verplicht",
            email: "Ongeldig e-mailformaat",
            phone: "Ongeldig telefoonformaat",
            website: "Ongeldig URL-formaat",
            password: "De code moet exact 6 cijfers bevatten"
        },
        ocr: {
            processing: "Kaart analyseren...",
            success: (n) => `Kaart geanalyseerd! ${n} veld${n > 1 ? 'en' : ''} ingevuld.`,
            noInfo: "Tekst gedetecteerd maar geen informatie herkend. Vul handmatig in.",
            error: "Kan kaart niet analyseren. Vul handmatig in.",
            unavailable: "OCR niet beschikbaar. Vul handmatig in.",
            invalidImage: "Selecteer een geldige afbeelding."
        }
    },
    es: {
        title: "Registro",
        subtitle: "Suba su tarjeta de visita o complete el formulario",
        uploadTitle: "Tarjeta de visita (Opcional)",
        optional: "(Opcional)",
        uploadPlaceholder: "Haga clic para subir una tarjeta de visita",
        uploadClick: "Haga clic para subir",
        uploadCardText: "una tarjeta de visita",
        analyzing: "Analizando...",
        firstName: "Nombre",
        lastName: "Apellido",
        email: "Correo electrónico",
        phone: "Teléfono",
        company: "Empresa",
        position: "Puesto",
        address: "Dirección",
        website: "Sitio web",
        password: "Código de acceso",
        passwordPlaceholder: "Código de 6 dígitos",
        passwordHelp: "⚠️ Importante: No use el mismo código que para sus datos sensibles (bancarios, etc.)",
        passwordError: "El código debe contener exactamente 6 dígitos",
        homeNeeds: "Necesidades del hogar",
        homeNeedsOptions: {
            electrician: "Electricista",
            plumber: "Fontanero",
            painter: "Pintor",
            carpenter: "Carpintero",
            roofing: "Techador",
            heating: "Técnico de calefacción",
            gardener: "Jardinero",
            cleaner: "Limpieza",
            renovation: "Renovación",
            other: "Otro"
        },
        submit: "Registrarse",
        submitting: "Registrando...",
        success: "¡Registro exitoso!",
        error: "Error durante el registro",
        validation: {
            required: "Este campo es obligatorio",
            email: "Formato de correo inválido",
            phone: "Formato de teléfono inválido",
            website: "Formato de URL inválido",
            password: "El código debe contener exactamente 6 dígitos"
        },
        ocr: {
            processing: "Analizando tarjeta...",
            success: (n) => `¡Tarjeta analizada! ${n} campo${n > 1 ? 's' : ''} completado${n > 1 ? 's' : ''}.`,
            noInfo: "Texto detectado pero no se reconoció información. Complete manualmente.",
            error: "No se puede analizar la tarjeta. Complete manualmente.",
            unavailable: "OCR no disponible. Complete manualmente.",
            invalidImage: "Por favor seleccione una imagen válida."
        }
    },
    it: {
        title: "Registrazione",
        subtitle: "Carica il tuo biglietto da visita o compila il modulo",
        uploadTitle: "Biglietto da visita (Opzionale)",
        optional: "(Opzionale)",
        uploadPlaceholder: "Clicca per caricare un biglietto da visita",
        uploadClick: "Clicca per caricare",
        uploadCardText: "un biglietto da visita",
        analyzing: "Analisi in corso...",
        firstName: "Nome",
        lastName: "Cognome",
        email: "Email",
        phone: "Telefono",
        company: "Azienda",
        position: "Posizione",
        address: "Indirizzo",
        website: "Sito web",
        password: "Codice di accesso",
        passwordPlaceholder: "Codice a 6 cifre",
        passwordHelp: "⚠️ Importante: Non usare lo stesso codice usato per i tuoi dati sensibili (bancari, ecc.)",
        passwordError: "Il codice deve contenere esattamente 6 cifre",
        homeNeeds: "Esigenze domestiche",
        homeNeedsOptions: {
            electrician: "Elettricista",
            plumber: "Idraulico",
            painter: "Pittore",
            carpenter: "Falegname",
            roofing: "Coperturista",
            heating: "Tecnico del riscaldamento",
            gardener: "Giardiniere",
            cleaner: "Pulizie",
            renovation: "Ristrutturazione",
            other: "Altro"
        },
        submit: "Registrati",
        submitting: "Registrazione in corso...",
        success: "Registrazione riuscita!",
        error: "Errore durante la registrazione",
        validation: {
            required: "Questo campo è obbligatorio",
            email: "Formato email non valido",
            phone: "Formato telefono non valido",
            website: "Formato URL non valido",
            password: "Il codice deve contenere esattamente 6 cifre"
        },
        ocr: {
            processing: "Analisi del biglietto in corso...",
            success: (n) => `Biglietto analizzato! ${n} campo${n > 1 ? 'i' : ''} completato${n > 1 ? 'i' : ''}.`,
            noInfo: "Testo rilevato ma nessuna informazione riconosciuta. Compila manualmente.",
            error: "Impossibile analizzare il biglietto. Compila manualmente.",
            unavailable: "OCR non disponibile. Compila manualmente.",
            invalidImage: "Seleziona un'immagine valida."
        }
    },
    pt: {
        title: "Registro",
        subtitle: "Carregue seu cartão de visita ou preencha o formulário",
        uploadTitle: "Cartão de visita (Opcional)",
        optional: "(Opcional)",
        uploadPlaceholder: "Clique para carregar um cartão de visita",
        uploadClick: "Clique para carregar",
        uploadCardText: "um cartão de visita",
        analyzing: "Analisando...",
        firstName: "Nome",
        lastName: "Sobrenome",
        email: "Email",
        phone: "Telefone",
        company: "Empresa",
        position: "Cargo",
        address: "Endereço",
        website: "Site",
        password: "Código de acesso",
        passwordPlaceholder: "Código de 6 dígitos",
        passwordHelp: "⚠️ Importante: Não use o mesmo código que para seus dados sensíveis (bancários, etc.)",
        passwordError: "O código deve conter exatamente 6 dígitos",
        homeNeeds: "Necessidades domésticas",
        homeNeedsOptions: {
            electrician: "Eletricista",
            plumber: "Encanador",
            painter: "Pintor",
            carpenter: "Carpinteiro",
            roofing: "Telhador",
            heating: "Técnico de aquecimento",
            gardener: "Jardineiro",
            cleaner: "Limpeza",
            renovation: "Renovação",
            other: "Outro"
        },
        submit: "Registrar",
        submitting: "Registrando...",
        success: "Registro bem-sucedido!",
        error: "Erro durante o registro",
        validation: {
            required: "Este campo é obrigatório",
            email: "Formato de email inválido",
            phone: "Formato de telefone inválido",
            website: "Formato de URL inválido",
            password: "O código deve conter exatamente 6 dígitos"
        },
        ocr: {
            processing: "Analisando cartão...",
            success: (n) => `Cartão analisado! ${n} campo${n > 1 ? 's' : ''} preenchido${n > 1 ? 's' : ''}.`,
            noInfo: "Texto detectado mas nenhuma informação reconhecida. Preencha manualmente.",
            error: "Não foi possível analisar o cartão. Preencha manualmente.",
            unavailable: "OCR não disponível. Preencha manualmente.",
            invalidImage: "Por favor, selecione uma imagem válida."
        }
    },
    el: {
        title: "Εγγραφή",
        subtitle: "Ανεβάστε την επαγγελματική σας κάρτα ή συμπληρώστε τη φόρμα",
        uploadTitle: "Επαγγελματική κάρτα (Προαιρετικό)",
        optional: "(Προαιρετικό)",
        uploadPlaceholder: "Κάνε κλικ για να ανεβάσεις μια επαγγελματική κάρτα",
        uploadClick: "Κάνε κλικ για να ανεβάσεις",
        uploadCardText: "μια επαγγελματική κάρτα",
        analyzing: "Ανάλυση...",
        firstName: "Όνομα",
        lastName: "Επώνυμο",
        email: "Email",
        phone: "Τηλέφωνο",
        company: "Εταιρεία",
        position: "Θέση",
        address: "Διεύθυνση",
        website: "Ιστοσελίδα",
        password: "Κωδικός πρόσβασης",
        passwordPlaceholder: "6ψήφιος κωδικός",
        passwordHelp: "⚠️ Σημαντικό: Μη χρησιμοποιείτε τον ίδιο κωδικό με τα ευαίσθητα δεδομένα σας (τραπεζικά, κλπ.)",
        passwordError: "Ο κωδικός πρέπει να περιέχει ακριβώς 6 ψηφία",
        homeNeeds: "Ανάγκες σπιτιού",
        homeNeedsOptions: {
            electrician: "Ηλεκτρολόγος",
            plumber: "Υδραυλικός",
            painter: "Ζωγράφος",
            carpenter: "Ξυλουργός",
            roofing: "Στεγαστής",
            heating: "Τεχνικός θέρμανσης",
            gardener: "Κηπουρός",
            cleaner: "Καθαρισμός",
            renovation: "Ανακαίνιση",
            other: "Άλλο"
        },
        submit: "Εγγραφή",
        submitting: "Εγγραφή σε εξέλιξη...",
        success: "Επιτυχής εγγραφή!",
        error: "Σφάλμα κατά την εγγραφή",
        validation: {
            required: "Αυτό το πεδίο είναι υποχρεωτικό",
            email: "Μη έγκυρη μορφή email",
            phone: "Μη έγκυρη μορφή τηλεφώνου",
            website: "Μη έγκυρη μορφή URL",
            password: "Ο κωδικός πρέπει να περιέχει ακριβώς 6 ψηφία"
        },
        ocr: {
            processing: "Ανάλυση κάρτας...",
            success: (n) => `Η κάρτα αναλύθηκε! ${n} πεδίο${n > 1 ? 'α' : ''} συμπληρώθηκε${n > 1 ? 'αν' : ''}.`,
            noInfo: "Εντοπίστηκε κείμενο αλλά δεν αναγνωρίστηκαν πληροφορίες. Συμπληρώστε χειροκίνητα.",
            error: "Αδυναμία ανάλυσης κάρτας. Συμπληρώστε χειροκίνητα.",
            unavailable: "Το OCR δεν είναι διαθέσιμο. Συμπληρώστε χειροκίνητα.",
            invalidImage: "Παρακαλώ επιλέξτε έγκυρη εικόνα."
        }
    }
};
